import { siteName } from 'config/site';
import React from 'react';
import { Box, Paper, Typography, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import LockResetIcon from '@mui/icons-material/LockReset';

/**
 * Full-page shell for standalone auth steps (reset password, verify email)
 * that leave the landing page — matches LandingAuth panel styling.
 */
const AuthFlowLayout = ({ children, onBack, title, subtitle, icon: Icon = LockResetIcon }) => (
  <Box
    sx={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      px: 2,
      py: 4,
    }}
  >
    <Paper
      elevation={24}
      sx={{
        p: { xs: 3, sm: 4 },
        borderRadius: 3,
        bgcolor: 'rgba(30, 41, 59, 0.95)',
        backdropFilter: 'blur(10px)',
        border: '1px solid rgba(255,255,255,0.1)',
        maxWidth: 440,
        width: '100%',
        position: 'relative',
      }}
    >
      {onBack && (
        <IconButton
          onClick={onBack}
          aria-label="Back to login"
          sx={{
            position: 'absolute',
            top: 8,
            left: 8,
            color: 'rgba(255,255,255,0.7)',
            '&:hover': {
              bgcolor: 'rgba(255,255,255,0.1)',
              color: 'white',
            },
          }}
        >
          <ArrowBackIcon />
        </IconButton>
      )}

      <Box sx={{ textAlign: 'center', mb: 3, pt: onBack ? 2 : 0 }}>
        <Box
          sx={{
            width: 56,
            height: 56,
            mx: 'auto',
            mb: 1.5,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: 'rgba(96, 165, 250, 0.15)',
            color: '#60a5fa',
          }}
        >
          <Icon sx={{ fontSize: 28 }} />
        </Box>
        <Typography
          variant="caption"
          sx={{
            color: 'rgba(255,255,255,0.5)',
            fontWeight: 600,
            letterSpacing: 0.5,
            textTransform: 'uppercase',
            display: 'block',
            mb: 0.5,
          }}
        >
          {siteName}
        </Typography>
        {title && (
          <Typography variant="h5" component="h1" fontWeight={700} sx={{ color: 'white', mb: 0.5 }}>
            {title}
          </Typography>
        )}
        {subtitle && (
          <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.65)', lineHeight: 1.5 }}>
            {subtitle}
          </Typography>
        )}
      </Box>

      {children}
    </Paper>
  </Box>
);

export default AuthFlowLayout;
